/**
 * checkoutUrl — single definition of "is this checkout_url a real external
 * payment page, or does it point back at our own API?"
 *
 * GatewayTest's checkout_url is built server-side from $_SERVER['HTTP_HOST']
 * (GatewayTestPlatformGateway::buildChargeUrl) — in every deployment that
 * resolves to the SAME host the frontend calls the API on (config.api.sistemaHost):
 * localhost:8080 in local dev, api-02.dev.newshoes.com on a remote dev slot, the
 * real API host in hml/prod. A real gateway's checkout_url (Stripe, ASAAS) never
 * matches that host.
 *
 * A literal 'localhost'/'127.0.0.1' comparison broke the moment the API got a
 * real hostname (S8R2-01): the GatewayTest checkout_url was misclassified as
 * external, window.location.assign() fired, and the SPA was torn down before
 * the fake-provider inline-pending path ever ran — every purchase smoke against
 * a remote slot died at that redirect, not at the wiring it exists to prove.
 */
import { config } from '../services/configService'

export function isExternalCheckoutUrl(url: string): boolean {
  let target: URL
  try {
    target = new URL(url)
  } catch {
    return false
  }

  if (target.protocol !== 'https:' && target.protocol !== 'http:') {
    return false
  }
  if (target.hostname === 'localhost' || target.hostname === '127.0.0.1') {
    return false
  }

  try {
    const apiHost = new URL(config.api.sistemaHost)
    if (target.hostname === apiHost.hostname) {
      return false
    }
  } catch {
    // config.api.sistemaHost always has a scheme (defaults to
    // 'http://localhost:8080') — this branch is unreachable in practice.
  }

  return true
}
